'use strict';
var slickConfigs = require('../config/slickConfigs');
var util = require('lyonscg/util/utils');
var ada = require('./ada');

/**
 * Init globally reusable carousels
 */

var carousels = {
    heroCarousels: function () {
        var $heroCaro = $('.hero-caro');
        if ($heroCaro.length) {
            $heroCaro.each(function () {
                var $slider = $(this);
                if (!$slider.hasClass('slick-initialized')) {
                    $slider.on('init afterChange', function () {
                        ada.accessbileSliders($slider);
                    })
                        .slick(slickConfigs.hero);
                }
            });
        }
    },
    productTileCarousels: function () {
        var $productTileCaro = $('.product-tile-carousel');
        if ($productTileCaro.length) {
            $productTileCaro.each(function () {
                var $slider = $(this);
                if (!$slider.hasClass('slick-initialized')) {
                    $slider.on('init afterChange', function () {
                        ada.accessbileSliders($slider);
                    })
                        .slick(slickConfigs.productTiles);
                }
            });
        }
        util.smartResize(function () {
            carousels.productTileCarousels();
        });
        if (window.affirm && typeof window.affirm.jsReady === 'function' && window.affirm.jsReady()) {
            window.affirm.ui.refresh();
        }
    },
    cartRecProductCarousels: function () {
        var $cartRecProductCaro = $('.cart-rec-product-carousel');
        if ($cartRecProductCaro.length) {
            $cartRecProductCaro.each(function () {
                var $slider = $(this);
                if (!$slider.hasClass('slick-initialized')) {
                    $slider.on('init afterChange', function () {
                        ada.accessbileSliders($slider);
                    })
                        .slick(slickConfigs.cartProductRecs);
                }
            });
        }
        util.smartResize(function () {
            carousels.cartRecProductCarousels();
        });
        if (window.affirm && typeof window.affirm.jsReady === 'function' && window.affirm.jsReady()) {
            window.affirm.ui.refresh();
        }
    },
    productTileInterceptCarousels: function () {
        var $productTileInterceptCaro = $('.product-tile-intercept-caro');
        if ($productTileInterceptCaro.length) {
            $productTileInterceptCaro.each(function () {
                var $slider = $(this);
                if (!$slider.hasClass('slick-initialized')) {
                    $slider.on('init afterChange', function () {
                        ada.accessbileSliders($slider);
                    })
                        .slick(slickConfigs.productTilesIntercept);
                }
            });
        }
    },
    headerPromoCarousels: function () {
        var $headerPromoCarousels = $('.header-promo-caro');
        if ($headerPromoCarousels.length) {
            $headerPromoCarousels.each(function () {
                var $slider = $(this);
                if (!$slider.hasClass('slick-initialized')) {
                    $slider.on('init afterChange', function () {
                        ada.accessbileSliders($slider);
                        var $activeSlide = $($slider).find('.slick-current .slide');
                        if ($($activeSlide).children('.header-promo-inner-wrapper').length < 1) {
                            $($activeSlide).children().wrapAll("<span class='header-promo-inner-wrapper'></span>");
                        }
                        // Get the width of inner elements of active slide to calculate responsive positioning for arrows.
                        var innerWidth = $($activeSlide).find('.header-promo-inner-wrapper').width();
                        var outerWidth = $($slider).parent().width();
                        var widthDiff = (((outerWidth - innerWidth) / 2) - 20);
                        $($slider).find('.slick-prev').css('margin-left', widthDiff);
                        $($slider).find('.slick-next').css('margin-right', widthDiff);
                    })
                        .slick(slickConfigs.headerPromo);
                }
            });
        }
    },
    contentBlockCarousels: function () {
        var $contentCarousels = $('.content-block-caro');
        if ($contentCarousels.length) {
            $contentCarousels.each(function () {
                var $slider = $(this);
                if (!$slider.hasClass('slick-initialized')) {
                    $slider.on('init afterChange', function () {
                        ada.accessbileSliders($slider);
                    })
                        .slick(slickConfigs.contentBlock);
                }
            });
        }
    },
    blogCarousels: function () {
        var $blogCarousels = $('.blog-tile-caro');
        if ($blogCarousels.length) {
            $blogCarousels.each(function () {
                var $slider = $(this);
                if (!$slider.hasClass('slick-initialized')) {
                    $slider.on('init afterChange', function () {
                        ada.accessbileSliders($slider);
                    })
                        .slick(slickConfigs.blogTiles);
                }
            });
        }
        util.smartResize(function () {
            carousels.blogCarousels();
        });
    },
    partsCarousels: function () {
        var $partsCarousels = $('.parts-tile-caro');
        if ($partsCarousels.length) {
            $partsCarousels.each(function () {
                var $slider = $(this);
                if (!$slider.hasClass('slick-initialized')) {
                    $slider.on('init afterChange', function () {
                        ada.accessbileSliders($slider);
                    })
                        .slick(slickConfigs.partsTiles);
                }
            });
        }
        util.smartResize(function () {
            carousels.partsCarousels();
        });
    },
    featureCarousels: function () {
        var $featureCarousels = $('.feature-caro');
        if ($featureCarousels.length) {
            $featureCarousels.each(function () {
                var $slider = $(this);
                if (!$slider.hasClass('slick-initialized')) {
                    $slider.on('init afterChange', function () {
                        ada.accessbileSliders($slider);
                    })
                        .slick(slickConfigs.feature);
                }
            });
        }
        util.smartResize(function () {
            carousels.featureCarousels();
        });
    },
    quickviewCarousel: function () {
        var $quickviewCarousels = $('.quickview-caro');
        if ($quickviewCarousels.length) {
            $quickviewCarousels.each(function () {
                var $slider = $(this);
                if (!$slider.hasClass('slick-initialized')) {
                    $slider.on('init afterChange', function () {
                        ada.accessbileSliders($slider);
                    })
                        .slick(slickConfigs.quickview);
                }
            });
        }
        util.smartResize(function () {
            carousels.quickviewCarousel();
        });
    },
    videoCarousels: function () {
        var $videoCarousels = $('.video-tile-caro');
        if ($videoCarousels.length && util.mediaBreakpointDown('sm')) {
            $videoCarousels.each(function () {
                var $slider = $(this);
                if (!$slider.hasClass('slick-initialized')) {
                    $slider.on('init afterChange', function () {
                        ada.accessbileSliders($slider);
                    })
                        .slick(slickConfigs.videoTiles);
                }
            });
        }
        util.smartResize(function () {
            carousels.videoCarousels();
        });
    },
    blogArticleCarousels: function () {
        var $blogArticleCarousels = $('.blog-tile-article');
        if ($blogArticleCarousels.length) {
            $blogArticleCarousels.each(function () {
                var $slider = $(this);
                if (!$slider.hasClass('slick-initialized')) {
                    $slider.on('init afterChange', function () {
                        ada.accessbileSliders($slider);
                    })
                        .slick(slickConfigs.blogArticle);
                }
            });
        }
        util.smartResize(function () {
            carousels.blogArticleCarousels();
        });
    }
};

module.exports = carousels;
